export class ClaimKey {
  source: string;
  claimId: string;
  lob: string;
  userOwns: boolean;
  claimNumber: string;
  hrMasterUid?: string;
  empUnum?: string;
}
